module.exports = __webpack_public_path__ + "img/568730hotel-costa-calero.c0de2883.jpg";